import { SVGIconProps } from '../types/svg';

export const Sinistres = (props: SVGIconProps) => (
    <svg width="50" height="51" viewBox="0 0 50 51" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
        <path
            d="M22.9314 10.4691C23.6254 9.09479 25.5469 8.98717 26.39 10.2754L42.9544 35.5832C43.7976 36.8714 42.93 38.5892 41.3928 38.6753L11.1934 40.3666C9.65625 40.4527 8.60231 38.8424 9.29635 37.4682L22.9314 10.4691Z"
            stroke="#00354F"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.6707 9.15438C10.9438 8.93725 11.3412 8.9826 11.5583 9.25569L14.7532 13.2738C14.9704 13.5469 14.925 13.9443 14.6519 14.1614C14.3788 14.3786 13.9814 14.3332 13.7643 14.0601L10.5694 10.042C10.3523 9.76891 10.3976 9.37152 10.6707 9.15438Z"
            fill="#278BE5"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.40636 20.1013C5.37132 19.7542 5.62432 19.4444 5.97144 19.4094L11.9676 18.8041C12.3148 18.7691 12.6246 19.022 12.6596 19.3692C12.6946 19.7163 12.4417 20.0261 12.0945 20.0611L6.09833 20.6664C5.75121 20.7014 5.4414 20.4485 5.40636 20.1013Z"
            fill="#FF8A02"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M43.0714 17.6328C43.0634 17.9816 42.7742 18.2579 42.4254 18.25L37.2932 18.1328C36.9444 18.1248 36.6681 17.8356 36.6761 17.4868C36.6841 17.138 36.9733 16.8617 37.3221 16.8697L42.4542 16.9869C42.803 16.9948 43.0793 17.284 43.0714 17.6328Z"
            fill="#278BE5"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M38.0302 6.58124C38.3193 6.77651 38.3954 7.16918 38.2001 7.4583L34.8272 12.4527C34.6319 12.7418 34.2393 12.8179 33.9501 12.6227C33.661 12.4274 33.5849 12.0347 33.7802 11.7456L37.1531 6.7512C37.3484 6.46208 37.7411 6.38598 38.0302 6.58124Z"
            fill="#FF8A02"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.5932 24.9858L30.4443 24.9582L24.4523 36.6067L24.4068 28.6078L19.5557 28.6354L25.5476 15.9869L25.5932 24.9858Z"
            stroke="#FF8A02"
            strokeLinejoin="round"
        />
    </svg>
);
